const getBaseClientHost = () => {
  if (import.meta.env.VITE_PUBLIC_CLIENT_HOST) {
    return import.meta.env.VITE_PUBLIC_CLIENT_HOST;
  }

  if (typeof window !== "undefined" && window.location.origin) {
    return window.location.origin;
  }

  return "";
};

export const getJobShareUrl = (jobId: string, referralCode?: string | null) => {
  const baseHost = getBaseClientHost();
  const basePath = jobId ? `${baseHost}/jobs/${jobId}` : baseHost;

  if (!referralCode) {
    return basePath;
  }

  try {
    const url = new URL(basePath);
    url.searchParams.set("l", referralCode);
    return url.toString();
  } catch (error) {
    return `${basePath}?l=${encodeURIComponent(referralCode)}`;
  }
};
